
export class LocationInvoiceDetail {
    id: number;
    offlineId: string;
    location: IlocationBase;
    timestamp: string;
    subTotal: number;
    total: number;
    type: number;

    constructor(locationInvoiceDetail: LocationInvoiceDetail) {
        Object.assign(this, locationInvoiceDetail);
    }
}

export interface IlocationBase {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/location/shared/models/location-invoice-detail.ts